


















































import request from '@/utils/request'
import addActiveDialog from './components/add-active-dialog.vue'
import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'active',
  components: { addActiveDialog }
})
export default class active extends Vue {
  active_id: String = ''
  isEdit: boolean = true
  activeFormData: any = {
    groupLimit: []
  }
  // queryFormData: any = {}
  activeDialogShow: boolean = false
  pageNumber: number = 0
  pageSize: number = 10
  totalElements: number = 0
  tableData: any = []
  options: any = []
  _self: any = this
  value: String = ''
  get isCn(): boolean {
    return this.$store.getters.i18nLocale === 'us' ? false : true
  }
  handleEdit(index: any, row: any) {
    row.orderBy = row.orderBy + ''
    this.activeFormData = row
    this.activeDialogShow = true
    console.log(index, row)
  }
  handleDelete(index: any, row: any) {
    this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.axios({
          url: '/iblac/active',
          method: 'delete',
          params: {
            id: row.id
          }
        })
          .then((res: any) => {
            this.fetchTableData()
            this.$message('删除成功')
          })
          .catch((err: any) => {
            console.log(err)
          })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    console.log(index, row)
  }
  mounted() {
    this.fetchTableData()
    this.fetchOption()
  }
  tableIndexMethod(index: number) {
    return this.pageNumber * this.pageSize + index + 1
  }
  tablePaging(pageNumber: any) {
    this.pageNumber = pageNumber - 1
    this.fetchTableData()
  }
  fetchOption() {
    this.axios({
      url: '/iblac/actives',
      method: 'get'
    })
      .then((response: any) => {
        let tmpData = response.data.content
        tmpData.forEach((ele: any) => {
          this.options.push({ label: ele.activeNameZh, value: ele.id })
        })
      })
      .catch((error: any) => {
        console.log(error)
      })
  }
  fetchTableData() {
    this.axios({
      url: '/iblac/actives',
      method: 'get',
      params: {
        page: this.pageNumber,
        size: this.pageSize,
        sort: 'orderBy,asc',
        eq_id: this.active_id
      }
    })
      .then((response: any) => {
        this.tableData = response.data.content
        this.tableData.forEach((ele: any) => {
          if (!ele.groupLimit) {
            this.$set(ele, 'groupLimit', [])
          } else {
            this.$set(ele, 'groupLimit', ele.groupLimit.split(','))
          }
        })
        console.log(this.tableData)
        this.totalElements = response.data.totalElements
      })
      .catch((error: any) => {
        console.log(error)
      })
  }
  saveActive() {
    const k = this.activeFormData['groupLimit']
    if (k instanceof Array) {
      this.$set(this.activeFormData, 'groupLimit', k.join(','))
    }
    this.axios
      .put('/iblac/active', this.activeFormData)
      .then((res: any) => {
        this.$message('保存成功')
        this.fetchTableData()
        this.axios({
          url: '/iblac/active/signSave',
          method: 'post',
          data: res.data,
        }).then(response => {
          console.log("签字验签返回的数据为：",response);
        }).catch(error => {
          console.log(error)
        })
      })
      .catch(err => {
        console.log(err)
      })
    this.close()
  }
  close() {
    this.activeDialogShow = false
    this.activeFormData = {
      groupLimit: []
    }
  }
}
